import { render, staticRenderFns } from "./UserHistoryTable.vue?vue&type=template&id=601a412e&scoped=true&"
import script from "./UserHistoryTable.vue?vue&type=script&lang=js&"
export * from "./UserHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./UserHistoryTable.vue?vue&type=style&index=0&id=601a412e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a412e",
  null
  
)

export default component.exports